<template>
    <dx-radio-group
        class="m-3"
        :items="items"
        :value="radioValue"
        @value-changed="onValueChanged"
        layout="horizontal"
    />
    <div class="flex h-full">
        <ai-tree-list-edit ref="treeListRef" class="gridContainer" :args="args" :meta="meta"></ai-tree-list-edit>
        <div class="flex flex-col h-full gap-2 grid-border max-w-sm">
            <div class="flex flex-col h-0 grow gridContainer">
                <dx-data-grid
                    ref="gridRef"
                    :hover-state-enabled="true"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :show-borders="true"
                    height="100%"
                    class="h-0 grow"
                    :columns="gridMeta?.columns"
                    :data-source="gridDataSource"
                    :toolbar="{ items: defaultButtons }"
                    :fixing="{ enabled: true }"
                    :header-filter="{ visible: true }"
                    :load-panel="{ enabled: true }"
                    :selection="{
                        mode: 'multiple',
                        showCheckBoxesMode: 'always',
                        allowSelectAll: meta?.allowSelectAll || false,
                    }"
                >
                    <dx-column
                        v-for="(item, index) in gridMeta.columns"
                        keyExpr="kod_sap"
                        :key="index"
                        :allow-editing="true"
                        :calculate-cell-value="item.calculateCellValue"
                        :calculate-display-value="item.calculateDisplayValue"
                        :caption="item.caption"
                        :cell-template="item.cellTemplate"
                        data-field="kod_sap"
                        :data-type="item.dataType || 'string'"
                        :component-meta="item.component"
                        :editor-meta="item.editor"
                        :editor-options="item.editorOptions"
                        :group-index="item.groupIndex"
                        :lookup="item.lookup || null"
                        :sort-index="item.sortIndex"
                        :sort-order="item.sortOrder"
                        :validation-rules="item.validationRules"
                        :visible="item.visible"
                        :width="item.width"
                        :show-in-column-chooser="item.showInColumnChooser || true"
                        :fixed="item.fixed"
                        headerCellTemplate="headerTemplate"
                    >
                    </dx-column>
                    <dx-editing
                        :allow-updating="true"
                        :allow-adding="true"
                        :allow-deleting="false"
                        start-edit-action="click"
                        mode="cell"
                    />
                    <template #titleButton>
                        <div class="flex gap-2">
                            <component :is="meta.icon" />
                            <h3>{{ `${meta.title}` }}</h3>
                        </div>
                    </template>
                    <template #headerTemplate="{ data: headerInfo }">
                        <div class="h-full flex items-start whitespace-normal break-words text-left line-clamp-3">
                            {{ headerInfo.column.caption }}
                        </div>
                    </template>
                </dx-data-grid>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'is-sprsmet-view',
};
</script>

<script setup>
import DxRadioGroup from 'devextreme-vue/radio-group';
import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid';
import aiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import { onMounted, reactive, ref } from 'vue';
import { meta, gridMeta } from './data';

const items = ['Текущее состояние', 'Все строки'];
const treeListRef = ref();
const treeListInstance = ref();
const gridDataSource = ref([]);
const gridRef = ref();
const gridInstance = ref();
const selectedRowKey = ref();
const radioValue = ref('Текущее состояние');

const state = reactive({
    treeListChanges: [],
});

onMounted(async () => {
    console.log(treeListRef.value);
    console.log(treeListRef.value.ref);

    await treeListRef.value.setCacheOrApiDataSource();
    gridInstance.value = gridRef.value.instance;
    treeListInstance.value = treeListRef.value.treeListInstance;
    treeListInstance.value.option('editing.changes', state.treeListChanges);

    gridInstance.value.on('optionChanged', handleGridOptionChanged);
    treeListInstance.value.on('focusedRowChanged', handleFocusedRowChanged);
});

const onValueChanged = event => {
    radioValue.value = event.value;
    args.select.select_args.selectArg = event.value;
    if (event.value === 'Все строки') {
        treeListInstance.value.columnOption('dat_finish_modified', 'visible', true);
        treeListInstance.value.columnOption('dat_start_modified', 'visible', true);
    } else {
        treeListInstance.value.columnOption('dat_finish_modified', 'visible', false);
        treeListInstance.value.columnOption('dat_start_modified', 'visible', false);
    }

    treeListRef.value.setDataSource(meta.api.select, args.select);
};

const onDeleteClick = () => {
    const keys = gridInstance.value.getSelectedRowKeys();
    for (let key of keys) {
        const index = gridInstance.value.getRowIndexByKey(key);
        gridDataSource.value.splice(index, 1);
    }

    gridDataSource.value = [...gridDataSource.value];
    updateTreeListChanges(gridDataSource.value.map(item => item.kod_sap).join(','));
    treeListInstance.value.refresh();
};

const handleGridOptionChanged = event => {
    if (event.fullName === 'editing.editRowKey') {
        if (event.previousValue) {
            updateTreeListChanges(gridDataSource.value.map(item => item.kod_sap).join(','));
            treeListInstance.value.refresh();
        }
    }
};

const handleFocusedRowChanged = event => {
    if (event.row) {
        selectedRowKey.value = event.row.key;
        const ds = event.row?.data.sap ? event.row.data.sap.split(',') : [];
        gridDataSource.value = ds.map(item => {
            return { kod_sap: item };
        });
        gridInstance.value.option('editing.changes', []);
    }
};

const updateTreeListChanges = restDataSource => {
    const existKey = treeListInstance.value.option('editing.changes').some(item => item.key === selectedRowKey.value);

    if (existKey) {
        treeListInstance.value.option(
            'editing.changes',
            treeListInstance.value
                .option('editing.changes')
                .map(change =>
                    change.key === selectedRowKey.value ? { ...change, data: { sap: restDataSource } } : change
                )
        );
    } else {
        treeListInstance.value
            .option('editing.changes')
            .push({ key: selectedRowKey.value, type: 'update', data: { sap: restDataSource } });
    }
    treeListRef.value.refreshSaveButtonDisable();
};

const addButton = {
    name: 'addRowButton',
};

const args = {
    select: {
        select_args: {
            selectArg: radioValue.value,
        },
    },
};

const deleteButton = {
    name: 'deleteButton',
    widget: 'dxButton',
    location: 'after',
    options: {
        hint: 'Удалить',
        icon: 'trash',
        onClick: onDeleteClick,
    },
};

const defaultButtons = [addButton, deleteButton];
</script>
<style scoped>
:deep(.dx-radiogroup-horizontal .dx-collection) {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.grid-border {
    border: 1px solid #e5e7eb;
    width: auto;
}

.gridContainer {
    width: 100%;
    overflow-x: auto;
}
</style>
